import { render, staticRenderFns } from "./CoreCompanyCard.vue?vue&type=template&id=edad86da"
import script from "./CoreCompanyCard.vue?vue&type=script&lang=js"
export * from "./CoreCompanyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports